import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchGameDetails, fetchWishlist, removeFromWishlist } from "../services/api";
import { jwtDecode } from "jwt-decode";

// Utility to get user ID from JWT token
function getUserId() {
  const token = localStorage.getItem("token");
  if (!token) return null;
  try {
    const decoded = jwtDecode(token);
    return decoded.id;
  } catch {
    return null;
  }
}

const Wishlist = () => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [wishlistReload, setWishlistReload] = useState(false); // trigger for force-refetch
  const token = localStorage.getItem("token");
  const userId = getUserId();

  // Fetch all wishlisted games from backend on mount or wishlistReload
  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      try {
        const wishlistItems = await fetchWishlist(userId, token);
        const details = await Promise.all(
          (wishlistItems || []).map(item => fetchGameDetails(item.game_id).catch(() => null))
        );
        setGames(details.filter(Boolean));
      } catch (e) {
        setGames([]);
      }
      setLoading(false);
    };
    if (userId && token) fetchAll();
  }, [userId, token, wishlistReload]);

  const handleRemove = async (gameId) => {
    try {
      await removeFromWishlist(userId, gameId, token);
      setWishlistReload(r => !r);
    } catch (e) {
      // Optionally show error to user
    }
  };

  const handleClear = async () => {
    try {
      await Promise.all(games.map(game => removeFromWishlist(userId, game.id, token)));
      setWishlistReload(r => !r);
    } catch (e) {
      // Optionally show error to user
    }
  };

  if (loading)
    return <div style={{ textAlign: "center", marginTop: 40 }}>Loading Wishlist...</div>;

  if (!games || games.length === 0)
    return (
      <div style={{ textAlign: "center", marginTop: 40 }}>
        Your wishlist is empty.<br /><Link to="/">Go discover games!</Link>
      </div>
    );

  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: 20 }}>
      <h1 style={{ textAlign: "center", margin: "25px 0 22px 0", fontSize: "2.4rem" }}>My Wishlist</h1>
      <button
        onClick={handleClear}
        style={{
          background: "#e74c3c",
          color: "#fff",
          border: "none",
          borderRadius: 12,
          padding: "8px 19px",
          fontSize: "1rem",
          fontWeight: "bold",
          marginBottom: "13px",
          cursor: "pointer"
        }}
      >
        Clear All Wishlist
      </button>
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: 30,
      }}>
        {games.map(game => (
          <div key={game.id} style={{
            background: "#23233a",
            borderRadius: 16,
            boxShadow: "0 2px 18px #0003",
            padding: 15,
            position: "relative",
            minHeight: 300
          }}>
            <Link to={`/games/${game.id}`} style={{ textDecoration: "none", color: "#a261e7" }}>
              <img src={game.background_image} alt={game.name}
                   style={{ width: "100%", borderRadius: 11, marginBottom: 12, height: 120, objectFit: "cover" }} />
              <div style={{
                fontWeight: "bold", fontSize: "1.16rem", marginBottom: 6, color: "#fff"
              }}>
                {game.name}
              </div>
            </Link>
            <div style={{ fontSize: "0.98rem", color: "#b4e7fd", marginBottom: 5 }}>
              Released: {game.released}
            </div>
            <button
              onClick={() => handleRemove(game.id)}
              style={{
                position: "absolute",
                top: 14,
                right: 14,
                background: "#a261e7",
                color: "#fff",
                border: "none",
                borderRadius: 14,
                padding: "3px 13px",
                cursor: "pointer"
              }}
            >Remove</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Wishlist;
